export const typography = {
  display: 'font-heading text-display text-text-heading [text-wrap:balance]',
  pageTitle: 'font-heading text-page-title text-text-heading [text-wrap:balance]',
  sectionTitle: 'font-body font-semibold text-section-title text-text-heading [text-wrap:balance]',
  cardTitle: 'font-body font-semibold text-card-title text-text-heading',
  eyebrow: 'font-body text-eyebrow text-text-muted uppercase',
  bodyLarge: 'font-body text-body-lg text-text-body',
  body: 'font-body text-body text-text-body',
  bodyComfort: 'font-body text-body-comfort text-text-body',
  bodySmall: 'font-body text-body-sm text-text-body',
  caption: 'font-body text-caption text-text-muted',
  metric: 'font-body text-metric text-text-heading tabular-nums',
} as const;

export type TypographyStyle = keyof typeof typography;
